export default __webpack_public_path__ + "static/logo-bank-nagari-9504f5ba7811a1bf93408e5cad46c355.webp";